import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import M from 'materialize-css/dist/js/materialize';
import LoadUnloadService from '../../../services/LoadUnloadService';
import { startLoading, endLoading } from '../../../actions/loadingAction';
import MdrService from '../../../services/MdrService';
import { hideSupplier } from '../../../actions/loadUnloadAction';
import ConfirmModal from '../../../components/UI/ConfirmModal';
import { isNullOrEmpty, translate, showMessageToast } from '../../../utils/util';
import CardUI from '../../../components/UI/CardUI';
import { Label } from '../../../components/UI/ComponentsUI';
import { LOAD_UNLOAD_JUSTIFICATION_LIST } from '../../../utils/constants';
import ConfirmModalUI from '../../../components/UI/ConfirmModalUI';
import Select from '../../../components/UI/Select';
import SelectNew from '../../../components/UI/SelectNew';

const LoadConfirmation = (props) => {
    const [modelMessage, setModelMessage] = useState({ title: "", message: "", justificationId: "" })
    const [model, setModel] = useState({ acaoConfirm: '', index: null });
    const [openModal, setOpenModal] = useState(false);


    useEffect(() => {
        if (!isNullOrEmpty(modelMessage.title) && !isNullOrEmpty(modelMessage.message)) {
            onOpenModal();
        }
        // eslint-disable-next-line
    }, [modelMessage]);

    const onJustificationChange = (event) => {
        model.justificationId = event.target.value;
        setModel({ ...model });

    };

    const showMessageModal = (title, message) => {
        const auxmodelMessage = {};
        Object.assign(auxmodelMessage, modelMessage);
        auxmodelMessage.title = title;
        auxmodelMessage.message = message;
        setModelMessage(auxmodelMessage);
    }

    const onOpenModal = () => {
        setOpenModal(true)
    }

    const closeModal = () => {
        setOpenModal(false)
    }

    const submitConfirm = () => {
        if (model.acaoConfirm === 'Confirmar') {
            if (verifyTolerance()) {
                if (isNullOrEmpty(model.justificationId)) {
                    showMessageToast({ html: 'Tempo de Tolerância excedido. Justificativa obrigatória.', classes: 'red' });
                }
                else {
                    submit();
                    closeModal();
                }
            } else {
                submit();
                closeModal();
            }

        } else if (model.acaoConfirm === 'Excluir') {
            props.deleteLoadItem(model.index);
            props.removeConfirmationMdrList(model.index);
            closeModal();
        }
    }

    const excluirItem = (index) => {
        model.acaoConfirm = translate('delete', 'general');
        model.index = index;
        setModel(model);
        showMessageModal(translate('delete', 'general'), translate('confirm-delete', 'load-unload'));
    }

    const confirmarCarga = () => {
        if (props.mvm.id === null || props.mvm === undefined) {
            showMessageToast({ html: translate('inf-mvm', 'physical-confirmation'), classes: 'red' });
            return;
        }
        model.acaoConfirm = translate('confirm', 'general');
        setModel(model);
        showMessageModal(translate('confirm', 'general'), translate('confirm-load', 'load-unload'));
    }

    const submit = () => {
        if (isNullOrEmpty(props.mvm)) {
            showMessageToast({ html: translate('inf-mvm', 'physical-confirmation'), classes: 'red' });
        } else {
            let putObj = {
                loadId: props.mvm.loadId,
                id: props.mvm.id,
                movementDescription: props.movementTypeObj?.movementType.description || '',
                shedCode: props.shedObj?.code || '',
                mvmNumber: props.mvm.mvmNumber,
                shed: {
                    id: props.mvm.sheds.find(i => i.shedId === parseInt(props.shed)).id, movementTypeId: props.movementType, meansOfMovement: "E",
                    justification: LOAD_UNLOAD_JUSTIFICATION_LIST.find(i => i.code === Number(model.justificationId))?.label,
                    rackLoads: []
                }
            };

            props.confirmationList.map((c) => {
                var company = getshippmentCompany(c.shippingCompany);
                putObj.shed.rackLoads.push({
                    loadType: 'R',
                    rackTypeId: c.rackType.id,
                    rackTypeCode: c.rackType.code,
                    rackTypeDescription: c.rackType.description,
                    rackTypeOwnerSupplierId: c.rackType.ownersupplierId === 0 ? 1080 : c.rackType.ownersupplierId,
                    mvmShedId: props.shed,
                    supplierId: c.supplier.supplierID,
                    supplierSapCode: c.supplier.supplierSapCode,
                    supplierName: c.supplier.name,
                    supplierUF: c.supplier.supplierUf,
                    rackTypeQuantity: c.qtd,
                    volumeQuantity: c.qtd,
                    shippingCompanyId: c.shippingCompany,
                    shippingCompanyUF: company.companyUF,
                    shippingCompanyCode: company.companyCode,
                    shippingCompanyName: company.companyName,
                    requestNumber: c.transportOrder,
                    indFullRack: c.indFullRack,
                    isPackingFCM: c.isPackingFCM,

                });
            });

            props.finishLoadUnload(putObj, () => {
                props.clearAll();
                document.getElementById('tabStartLoadUnload').click();
            });
        }

        showMessageModal("", "");
    }

    const getshippmentCompany = (value) => {
        if (!isNullOrEmpty(value) && props?.shedObj?.companies && props.shedObj.companies.length > 0) {
            return props?.shedObj?.companies.find((f) => f.companyId === parseInt(value))
        }
        return null;
    }

    const verifyTolerance = () => {

        var shedIndConfirmCargoInAe = props.shedConfigs.find(i => i.shedId === Number(props.shed) && i.movementTypeId === Number(props.movementType))?.indConfirmCargoInAe;
        if (shedIndConfirmCargoInAe) {
            return false;
        }
        var shedValidate = props.mvm.sheds.find(i => i.shedId === Number(props.shed))
        const date = new Date(shedValidate.checkInDate);

        const [hours, minutes, seconds] = shedValidate.tolerance.split(':').map(Number);

        const toleratedDate = new Date(date);
        toleratedDate.setHours(date.getHours() + hours);
        toleratedDate.setMinutes(date.getMinutes() + minutes);
        toleratedDate.setSeconds(date.getSeconds() + seconds);

        const now = new Date();

        return now > toleratedDate;
    }


    const renderButton = () => {

        return (<div className="row">
            {!props?.mvm?.load?.indSentAe &&
                <div className="col s12">
                    <span className="input-group-btn">
                        <button
                            className="btn
                                    btn-large
                                    btn-principal
                                    waves-effect
                                    waves-light"
                            type="button"
                            onClick={() => confirmarCarga()}
                        >
                            {translate('confirm', 'general')}
                            <i className="material-icons right">check_circle</i>
                        </button>
                    </span>
                </div>
            }
            {
                !isNullOrEmpty(modelMessage.title) && !isNullOrEmpty(modelMessage.message) &&
                <ConfirmModalUI
                    open={openModal}
                    showCancel="true"
                    validationInput="true"
                    id="confirmJustificationModal"
                    data={{
                        title: `${modelMessage.title}`,
                        message: <>
                            <div className="row" style={{ marginBottom: '0px' }}>
                                {modelMessage.message}
                            </div>
                            {
                                verifyTolerance() &&
                                <div id="confirmJustificationModal" className="row" style={{ marginBottom: '0px' }}>
                                    <div className="row" style={{ marginBottom: '0px', color: "red" }}>
                                        Tempo de Tolerância excedido. Justificativa obrigatória.
                                    </div>
                                    <div className="padding col s12">
                                        <SelectNew
                                            required
                                            id="justificationId"
                                            name="model.justificationId"
                                            placeHolder={translate("delivery:fields.justification")}
                                            defaultValue={model.justificationId || ""}
                                            label={translate("delivery:fields.justification")}
                                            change={(el) => { onJustificationChange(el); }}
                                            data={LOAD_UNLOAD_JUSTIFICATION_LIST.map((i) => { return { id: i.code, text: i.label }; })}
                                        />
                                    </div>
                                </div>
                            }
                        </>
                    }}
                    onConfirm={() => {
                        setOpenModal(false)
                        submitConfirm()
                    }}
                    onCancel={() => setOpenModal(false)}
                    onClose={() => setOpenModal(false)}
                    btnCancel={translate('cancel', 'general')}
                    btnConfirm={translate('confirm', 'general')}
                />
            }
        </div>)
    }

    return (
        !props.disableList ?
            <div>
                <div className="container-fluid h-65" />
                <div className="container">
                    {renderButton()}
                    {
                        props?.confirmationList?.length !== 0 &&
                        (<div className="">
                            <br />
                            {translate('confirm-unload', 'load-unload')}:
                            {
                                props.confirmationList?.map((item, index) => {
                                    if (!item.excluded) {
                                        return (
                                            <CardUI style={{ paddingBlockEnd: '5px' }} key={`${item.rackType?.code}-${index}`}>
                                                <fieldset className='fieldset'>
                                                    <div className='row' style={{ padding: '10px' }}>
                                                        <div className='col s10'>
                                                            <div className="row" style={{ marginBottom: '0px' }}>
                                                                <Label field="f-1.5r" class="col s12" id="supplier" label={translate('supplier', 'load-unload')} value={`${item.supplier?.supplierID}-${item.supplier?.name}`} />
                                                                <Label field="f-1.5r" class="col s6" id="rackType" label={translate('mdr', 'load-unload')} value={`${item.rackType?.code}-${item.rackType?.description}`} />
                                                                <Label field="f-1.5r" class="col s5" id="length" label={translate('qtd', 'load-unload')} value={item?.qtd} />
                                                                <Label field="f-1.5r" class="col s12" id="length" label={translate('shipping-company', 'load-unload')} value={getshippmentCompany(item?.shippingCompany)?.companyName} />
                                                                {
                                                                    !isNullOrEmpty(item.transportOrder) &&
                                                                    <Label field="f-1.5r" class="col s12" id="length" label={translate('transport-order', 'load-unload')} value={item.transportOrder} />
                                                                }
                                                            </div>
                                                        </div>
                                                        {!props?.mvm?.load?.indSentAe &&
                                                            <div className="col s2">
                                                                <button
                                                                    className="circle center btn-flat"
                                                                    type="button"
                                                                    onClick={() => excluirItem(index)}
                                                                >
                                                                    <i className="material-icons red-text btn-circle-i btn-circle-i-med" >
                                                                        delete
                                                                    </i>
                                                                </button>
                                                            </div>
                                                        }
                                                    </div>
                                                </fieldset>
                                            </CardUI>
                                        );
                                    }
                                })
                            }
                        </div>)
                    }

                </div>
            </div> : renderButton()

    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        config: state.configReducer.config,
        confirmationList: state.loadUnloadReducer.confirmationList,
        mdrList: state.mdrReducer.list,
        mvm: state.loadUnloadReducer.mvm,
        shedObj: state.loadUnloadReducer.shedObj,
        shed: state.loadUnloadReducer.shed,
        movementType: state.loadUnloadReducer.movementType,
        movementTypeObj: state.loadUnloadReducer.movementTypeObj,
        shedConfigs: state.loadUnloadReducer.shedConfigs
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        removeConfirmationMdrList: (item) => {
            dispatch(LoadUnloadService.removeConfirmationMdrList(item));
        },
        deleteLoadItem: (item, callback) => {
            dispatch(LoadUnloadService.deleteLoadItem(item, callback));
        },
        finishLoadUnload: (putObj, callback) => {
            dispatch(LoadUnloadService.finishrackload(putObj, callback));
        },
        clearMdrList: () => {
            dispatch(MdrService.clearMdrList());
        },
        clearAll: () => {
            dispatch(LoadUnloadService.clearAll());
        },
        hideSupplierDropdown: () => {
            dispatch(hideSupplier());
        },
        showLoading: () => {
            dispatch(startLoading());
        },
        hideLoading: () => {
            dispatch(endLoading());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(LoadConfirmation));